import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBell2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bell-2, notification, activity, alert"><path d="M20.25 17.25H3.75V16L5.29688 13L5.50351 8.90897C5.6766 5.45882 8.53386 2.75 12 2.75C15.4661 2.75 18.3234 5.45882 18.4965 8.90897L18.7031 13L20.25 16V17.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8.0199 17.6512C8.22114 19.672 9.9263 21.25 12 21.25C14.0738 21.25 15.7789 19.672 15.9802 17.6512" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBell2;
